<mat-toolbar class="page-header">
  <span>Data Export</span>
</mat-toolbar>

@if (loaders()?.getDataExportJobs) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="page-container">
  <!-- Left Column -->
  <div class="left-column">
    <mat-card
      style="flex: 1"
      class="mat-elevation-z0">
      <mat-card-content style="display: flex; flex-direction: column; flex: 1; padding: 0">
        <form
          class="export-form"
          [formGroup]="exportForm">
          <!-- Effective Date -->
          <div class="eff-date-section">
            <p class="section-title">Effective Date</p>
            <div class="wrapper">
              <mat-form-field class="full-width">
                <app-custom-datepicker-tz
                  [displayAiracDates]="true"
                  formControlName="effectiveDate"
                  #startPicker>
                </app-custom-datepicker-tz>

                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="!fc.effectiveDate.value ? startPicker.openOverlay() : fc.effectiveDate.setValue(null)">
                  <mat-icon>{{ !fc.effectiveDate.value ? "today" : "close" }}</mat-icon>
                </button>
                @if (fc.effectiveDate.touched || fc.effectiveDate.dirty) {
                <mat-error>Effective date is required</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="time-field">
                <input
                  [disabled]="!fc.effectiveDate.value"
                  matInput
                  type="time"
                  (change)="onTimeChange($event, 'effectiveDate')"
                  [value]="fc.effectiveDate.value | dateTz : 'HH:mm' : 'UTC'" />
              </mat-form-field>
            </div>
          </div>

          <!-- Selected Database Option -->
          <!-- Temporary hide this section completely-->
          <!-- <div class="database-section">
            <p class="section-title">Select Database</p>
            <mat-radio-group [class.error]="fc.database.errors && fc.database.touched" formControlName="database"
              aria-label="Select databse">
              @for (item of targetDatabaseOptions; track $index) {
              <mat-radio-button color="primary" [value]="item.value">
                {{ item.label }}
              </mat-radio-button>
              }
            </mat-radio-group>
            @if (fc.database.errors && fc.database.touched) {
            <p class="custom-hint">Please choose a target database</p>
            }
          </div> -->

          <div class="temporary-changes-section">
            <p class="section-title">Temporary Changes</p>
            <mat-button-toggle-group
              formControlName="temporaryChanges"
              name="fontStyle"
              aria-label="Font Style">
              @for (item of temporaryChangesOptions; track $index) {
              <mat-button-toggle
                [value]="item.value"
                [matTooltip]="item.tooltipText"
                >{{ item.label }}
              </mat-button-toggle>
              }
            </mat-button-toggle-group>
          </div>

          <!-- Dataset Scope section -->
          <div class="dataset-scope-section">
            <p class="section-title">Dataset Scope</p>
            <!-- <ng-container formGroupName="icaoDataset">
              @for (control of icaoDatasetControl.controls | keyvalue; track $index; let i = $index) {
              <mat-checkbox [formControlName]="control.key">
                {{ icaoOptions[i].label }}
              </mat-checkbox>
              }
            </ng-container> -->
            <mat-form-field>
              <mat-select
                placeholder="Select a dataset scope"
                formControlName="icaoDataset">
                @for (option of icaoOptions; track option) {
                <mat-option [value]="option">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Post Export Options -->
          <div class="post-export-section">
            <p class="section-title">Export Options</p>
            <mat-form-field class="full-width post-export-select">
              <mat-select
                placeholder="Select post-export processing options"
                formControlName="postProccessing">
                @for (option of postProccesingOptions; track option) { @if (option.displayed) {
                <mat-option [value]="option.key">{{ option.label }}</mat-option>
                } }
              </mat-select>
              <mat-error>Post export processing option is required</mat-error>
            </mat-form-field>
          </div>

          <!-- Export format section -->
          <div class="export-format">
            <p class="section-title">Export Format</p>
            <mat-form-field class="full-width export-format-select">
              <mat-select
                placeholder="Select an export format"
                formControlName="format">
                @for (option of formatOptions; track option) { @if (option.displayed){
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                } }
              </mat-select>
              @if (fc.format.errors && fc.format.touched) {
              <mat-error>Please choose an export format</mat-error>
              }
            </mat-form-field>
          </div>
        </form>
        <mat-divider></mat-divider>
        <!-- Actions -->
        <div class="actions">
          <button
            mat-stroked-button
            (click)="resetExportForm()">
            Reset Form
          </button>
          <button
            mat-flat-button
            color="primary"
            (click)="generateDataset()">
            Generate Dataset
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Right Column -->
  <div class="right-column">
    <!-- Timeline Row -->
    @if (enableTimeline()) {
    <mat-card class="timeline-card mat-elevation-z0">
      <mat-card-title class="mx-1">
        <div class="title-wrapper">
          <span>Data Timeline</span>
          <div class="timeline-group-btn">
            <button
              mat-icon-button
              (click)="fitTimeLine()">
              <mat-icon>
                <span class="material-symbols-outlined">cell_merge</span>
              </mat-icon>
            </button>
          </div>
        </div>
        <div class="mat-body-2 timeline-info">
          <mat-icon><span class="material-symbols-outlined">info</span></mat-icon>
          <i> Click on an AIS Product on the timeline to pick an effective date for generating a dataset </i>
        </div>
      </mat-card-title>
      <mat-card-content class="py-0">
        <div
          #timeline
          class="timeline-container"></div>
      </mat-card-content>
    </mat-card>
    }

    <!-- Table Row -->
    <mat-card class="table-card mat-elevation-z0">
      <mat-card-title class="mx-1">
        Exported Datasets
         @if (countDown()) {
        <div class="mat-body-2 countdown-info">
          <mat-icon><span class="material-symbols-outlined">info</span></mat-icon>
          <i>Will auto-refresh the lists in {{ countDown() }} {{ countDown() > 1 ? "seconds" : "second" }} </i>
        </div>
        }
      </mat-card-title>
      <mat-card-content class="py-0">
        <table
          mat-table
          matSort
          matSortActive="exportDate"
          matSortDirection="desc"
          multiTemplateDataRows
          [dataSource]="dataSource()"
          class="mat-elevation-z0 full-width">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef>
              Dataset Scope
            </th>
            <td
              mat-cell
              *matCellDef="let element">
              <!-- {{ element.datasetUuid }} -->
              Full Dataset
            </td>
          </ng-container>

          <!-- Effective Date Column -->
          <ng-container matColumnDef="effectiveDate">
            <th
              mat-header-cell
              *matHeaderCellDef>
              Effective Date
            </th>
            <td
              mat-cell
              *matCellDef="let element">
              <span style="text-transform: uppercase">{{
                element.exportRequestDTO?.effectiveDate | dateTz : "DD MMM YYYY HH:mm A z" : "UTC"
              }}</span>
            </td>
          </ng-container>

          <!-- Export Date Column -->
          <ng-container matColumnDef="exportDate">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef>
              Export Date
            </th>
            <td
              mat-cell
              *matCellDef="let element">
              <span style="text-transform: uppercase">{{
                element.exportDate | dateTz : "DD MMM YYYY HH:mm A z" : "UTC"
              }}</span>
            </td>
          </ng-container>

          <!-- Size Column -->
          <ng-container matColumnDef="size">
            <th
              mat-header-cell
              *matHeaderCellDef>
              Size
            </th>
            <td
              mat-cell
              *matCellDef="let element">
              {{ element.size }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="exportStatus">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef>
              Status
            </th>
            <td
              mat-cell
              *matCellDef="let element">
              <div class="badge-container">
                <div
                  class="badge"
                  [class]="element.exportStatus?.toLowerCase()"
                  [ngClass]="{
                    'in-progress': element.exportStatus?.toLowerCase() === status.PROCESSING.toLowerCase(),
                    'not-started': element.exportStatus?.toLowerCase() === status.NOT_STARTED.toLowerCase(),
                    'timed-out': element.exportStatus?.toLowerCase() === status.TIMED_OUT.toLowerCase()
                  }">
                  <mat-icon>
                    <span class="material-symbols-outlined">
                      {{ iconLookup[element.exportStatus?.toLowerCase()] }}
                    </span>
                  </mat-icon>
                  <span>{{ labelLookup[element.exportStatus?.toLowerCase()] }}</span>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef>
              Actions
            </th>
            <td
              mat-cell
              *matCellDef="let element">
              <button
                mat-icon-button
                [disabled]="element.exportStatus !== status.COMPLETED"
                color="primary"
                (click)="downloadDataset(element); $event.stopPropagation()">
                <mat-icon>
                  <span class="material-symbols-outlined">download</span>
                </mat-icon>
              </button>
              <button
                color="primary"
                mat-icon-button
                (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()">
                <mat-icon>
                  <span class="material-symbols-outlined">info</span>
                </mat-icon>
              </button>
              <!-- <button mat-icon-button (click)="$event.stopPropagation()">
                <mat-icon>
                  <span class="material-symbols-outlined">overview</span>
                </mat-icon>
              </button> -->
            </td>
          </ng-container>

          <!-- Expanded Content Column  -->
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="columnsToDisplay.length">
              <div
                class="element-detail"
                [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                <mat-tab-group
                  class="row-detail-tab-group"
                  animationDuration="0ms"
                  mat-stretch-tabs="false">
                  <mat-tab label="Details">
                    <ng-container *ngTemplateOutlet="detailTpl; context: { $implicit: element }"></ng-container>
                  </mat-tab>
                  @if (element.exportMessage) {
                  <mat-tab label="Messages">
                    <ng-container *ngTemplateOutlet="messagesTpl; context: { $implicit: element }"></ng-container>
                  </mat-tab>
                  }
                </mat-tab-group>
              </div>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: columnsToDisplay"
            class="element-row row-bordered"
            [class.expanded-row]="expandedElement === row"
            [ngClass]="{
              'row-completed': row.exportStatus === status.COMPLETED,
              'row-processing': row.exportStatus === status.PROCESSING,
              'row-failed': row.exportStatus === status.FAILED,
              'row-not-started': row.exportStatus === status.NOT_STARTED,
              'row-timed-out': row.exportStatus === status.TIMED_OUT
            }"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="detail-row"></tr>
        </table>
        @if (!dataSource()?.data?.length) {
        <div class="no-data-section">
          <mat-icon><span class="material-symbols-outlined">info</span></mat-icon>
          <span>No datasets available</span>
        </div>
        }
      </mat-card-content>
    </mat-card>
    <mat-paginator
      [pageSize]="25"
      [pageSizeOptions]="[10, 25, 50]"
      [length]="dataSource()?.data?.length"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

<ng-template
  #confirmationTpl
  let-data>
  <h2 mat-dialog-title>Generate Dataset</h2>
  <mat-dialog-content>
    <p>Are you sure you want to generate dataset with the selected values?</p>
    <div class="confirmation-values-list">
      @for (item of data.contentEntries; track $index) {
      <div class="list-item-wrapper">
        <div class="list-item-title">{{ item.label }}</div>
        <div class="list-item-line">{{ item.content }}</div>
      </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      mat-button
      mat-dialog-close>
      Cancel
    </button>

    <button
      mat-flat-button
      color="primary"
      [mat-dialog-close]="true">
      Confirm
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template
  #detailTpl
  let-element>
  <div class="element-description">
    <div class="description-wrapper">
      <strong>Effective Date :</strong>
      <span>
        {{ element.exportRequestDTO?.effectiveDate | dateTz : "DD MMM YYYY HH:mm A z" : "UTC" }}
      </span>
    </div>
    <div class="description-wrapper">
      <strong>Temporary Changes :</strong>
      <span>{{ element.exportRequestDTO?.temporaryChanges ? "Applied" : "Ignored" }}</span>
    </div>
    <div class="description-wrapper">
      <strong>Export Options :</strong>
      <span>
        {{ postExportLookup[element.exportRequestDTO?.postProccessing] ?? "-" }}
      </span>
    </div>
    <div class="description-wrapper">
      <strong>Export format :</strong>
      <span>AIXM {{ element.exportRequestDTO?.format ?? "5.1.1" }}</span>
    </div>
    <div class="description-wrapper">
      <strong>Dataset UUID :</strong>
      <span>{{ element.datasetUuid }}</span>
    </div>
  </div>
</ng-template>

<ng-template
  #messagesTpl
  let-element>
  {{ element.exportMessage }}
</ng-template>
